// extracted by mini-css-extract-plugin
export default {"root":"OurTeam_root__+5e1q","info":"OurTeam_info__zc1QP","image":"OurTeam_image__ABcEx","description":"OurTeam_description__itEA8"};